import { CqsDto } from "@/lib/cqs";


export class GetSetupQuery extends CqsDto {
    public static CqsDtoType = "GetSetupQuery";
}

export class GetSetupQueryResult {
    constructor (
        public isShowEstimation: boolean,
        public isShowEstimationOnCardFront: boolean,
        public isShowEstimationOnCardBack: boolean,

        public isEnableEditEstimation: boolean,
        public storyPointScale: string,
        public isStoryPointScaleValueCustomizable: boolean,
        public isMarkBigStoryCards: boolean,
        public bigStoryLimit: string,

        public isShowStoryAttachemtns: boolean,

        public isShowReleases: boolean,
        public isShowReleasesOnCardFront: boolean,
        public isShowReleasesOnCardBack: boolean,

        public isShowCardContext: boolean,
        public isShowCardContextGoalOnCardFront: boolean,
        public isShowCardContextStepOnCardFront: boolean,
        public isShowCardContextOnCardBack: boolean,

        public isShowAnnotations: boolean,
        public isShowAnnotationsOnCardFront: boolean,
        public isShowAnnotationsOnCardBack: boolean,
        public selectedAnnotations: string[]
    ) {}
}

export class GetCardDataQueryResult {
    constructor(
        public estimation: number,
        public release: string,
        public goal: string,
        public step: string,
        public attachments: CardAttachment[],
        public annotations: CardAnnotation[]
    ) {}
}

export class CardAttachment {
    constructor(
        public isFile: boolean,
        public isImage: boolean,
        public isLink: boolean,
        public url: string,
        public title: string,
        public extension: string,
        public addedAt:string
    ) {
    }
}

export class CardAnnotation {
    constructor(
        public name:string
    ) {}
}

export class IsEmailAlreadyTakenQuery extends CqsDto {
    public static CqsDtoType = "IsEmailAlreadyTakenQueryLocale";

    constructor(
        public emailAddress: string,
    ) {
        super();
    }
}
